import { useUserData } from '~/composables/useUserData';

export default function (): boolean {
  const { $debug } = useNuxtApp();
  const { isCompleteRegulatoryRegisterEnabled } = useAuth();
  const { hasBankAccount } = useUserData();

  try {
    const hasBankAccountActive = computed<boolean>(() => {
      return hasBankAccount.value && isCompleteRegulatoryRegisterEnabled.value;
    });

    if ($debug.isEnabled) {
      console.groupCollapsed('🗺️ ~ BANK-ACCOUNT VALIDATION:\n');
      coloredDebug(hasBankAccountActive.value);
      console.groupEnd();
    }

    return hasBankAccountActive.value;
  } catch (err) {
    if ($debug.isEnabled) {
      console.groupCollapsed('🗺️ ~ BANK-ACCOUNT VALIDATION:\n');
      console.error(err);
      coloredDebug(false);
      console.groupEnd();
    }

    return false;
  }
}
